import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';

import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

const PageTemplate = css`
  .site-main {
    background: #fff;
    padding-bottom: 4vw;
  }
`;

const DevEnv: React.FunctionComponent = () => (
  <IndexLayout>
    <Helmet>
      <title>Środowisko pracy developerów</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>Środowiska pracy developerów</PostFullTitle>
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <h2>Lokalne środowisko pracy</h2>
              <p>
                Dajemy wolność wyboru co do systemu operacyjnego - MacOS X, Windows, Linux...<br />
                Pierwszym wymaganym składnikiem systemowym jest Git w jak najnowszej wersji.
              </p>
              <p>
                Każdy developer powinien zainstalować aplikację <a href="https://slack.com/">Slack</a> - jest to nasz komunikator firmowy. Każda osoba powinna mieć dostęp do naszego systemu <a href="https://app.clickup.com/">Clickup</a>. Dane dostępowe do wszystkich systemów udostępnia lider zespołu / ktoś z UK teamu. Oprócz tego każdy developer posiada swoją skrzynkę mailową, którą należy regularnie sprawdzać i mieć włączone notyfikacje (tak samo jak w przypadku Slacka).
              </p>
              <h4>Back-end / PHP Developer</h4>
              <p>
                Większość projektów można uruchomić na Dockerze, dzięki <b>docker-compose.yml</b> umieszczonemu w root'cie projektu.<br />Projekty "niezdockerowane" można uruchomić za pośrednictwem manualnie zainstalowanych na komputerze developera komponentów takich jak <b>Nginx (1.10.x), PHP 7.4, MySQL 5.7+ (preferowane 8.0)</b>.<br /><br />
                Potrzebny będzie <b>Composer</b> (im nowsza wersja, tym lepiej).
              </p>

              <h4>Front-end Developer</h4>
              Front-endowe projekty mogą się różnić między sobą odnośnie potrzebnych komponentów do ich uruchomienia. Standardowo na pewno potrzebny jest <b>NodeJS</b> w wersji przynajmniej 8.11.x i <b>NPM</b> w wersji od 6.13.<br /><br />
              Reszta składników zależy od projektów - podczas instalacji wg readme na pewno poradzisz sobie, aby doinstalować ewentualne brakujące komponenty.

              <hr />
              <h2>Staging</h2>
              <p>Staging w naszej firmie to tzw. bigpic.dev (<a href="https://bigpic.dev">https://bigpic.dev</a>). Każdy projekt ma swoje odzwierciedlenie na stagingu, np.: <a href="http://swiftpak-cms.bigpic.dev">http://swiftpak-cms.bigpic.dev</a>, <a href="https://ans-global.bigpic.dev">https://ans-global.bigpic.dev</a>, <a href="https://unicorn.bigpic.dev">https://unicorn.bigpic.dev</a> itd.
              </p>
              <p>
                Staging jest uruchomiony na <a href="https://www.digitalocean.com">DigitalOcean</a>, wraz z panelem administratora całego serwera o nazwie <a href="https://runcloud.io/">Runcloud</a>. Czasem, ze względu na nietypowe wymagania projektowe, tworzymy staging projektu bezpośrednio na serwerze klienta.
              </p>
              <p>
                Aby połączyć się do stagingu w celu np. przełączenia brancha albo uruchomienia migracji, należy połączyć się przez panel Runcloud (dane na LastPassie jako <em>RunCloud - Staging Server Control Panel</em>).
              </p>
              <p>
                <b>Więcej informacji na temat stagingu (jak samodzielnie tworzyć instancje projektów, przełączać branch itd.) znajdziesz <a href="/staging-instrukcje/">w tym dedykowanym artykule, opisującym stagingowe środowisko</a>.</b>
              </p>
              <p>
                Jeżeli korzystasz z <b>PHPMyAdmin</b>, to na stagingu mamy uruchomioną tę aplikację pod adresem <a href="https://pma.bigpic.dev/">pma.bigpic.dev</a>. Wystarczy podać login i hasło uzytkownika powiązanego z bazą danych utworzoną na stagingu, danego projektu.
              </p>

              <hr />
              <h2>Produkcja</h2>
              <p>
                Produkcyjne środowiska dla projektów w większości przypadków są uruchamiane i zarządzane przez nas na platformie <a href="https://www.digitalocean.com/">DigitalOcean</a>. Jak zazwyczaj tworzymy środowiska produkcyjne, <a href="/jak-stworzyc-webowy-serwer-na-digitalocean/">można zobaczyć w filmie tutaj</a>.
              </p>
              <p>
                Deploy na produkcyjne środowiska odbywa sie z wykorzystaniem <a href="http://138.68.166.65:8080/">Jenkins</a>a (dane do logowania na LastPassie jako <em>Jenkins (panel)</em>. W momencie commita na branch master w repozytorium danego projektu, uruchamiany jest job na Jenkinsie odpowiadający temu projektowi (automatycznie).
              </p>
              <p>
                <b>Proces samodzielnego tworzenia produkcyjnych środowisk znajdziesz w tym repozytorium: <a href="https://bitbucket.org/snowflakers/server-nginx-configuration/src">Nginx server configuration & hardening</a>.</b>
              </p>
            </div>
          </PostFullContent>
        </article>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default DevEnv;
